export const tabsStyle = {
  backgroundColor: "#1e1e1e !important", // Background color for the tabs
  color: "#white", // Text color for the tabs
  boxShadow: "none",
};

export const tabStyle = {
  backgroundColor: "#1e1e1e",
  color: "white",
  display: "flex",
  fontSize: "14px",
  width: "160px",
  // padding: '12px 16px',
  // marginLeft: '20px',
  // fontWeight: '800',
  textTransform: "none",
};

export const confirmBtnStyle = {
  backgroundColor: "#286685",
};

export const cancelBtnStyle = {
  backgroundColor: "rgb(117 130 137)",
};

export const buttonStyle = {
  padding: "5px 10px",
  background: "linear-gradient(135deg, #4f4f4f, #1e1e1e)",
  border: "1px solid #3a3a3a",
  color: "#ffffff",
  /* font-weight: 600; */
  fontSize: "5px",
  borderRadius: "6px",
  cursor: "pointer",
  boxShadow: "0 0 8px rgba(0, 0, 0, 0.6)",
  transition: "background 0.3s ease, transform 0.2s ease",
};
